import classNames from 'classnames'
import { IBalanceOfTrade } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFieldByActualsValueType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFieldByActualsValueType'
import { getTwoLastSymbolsOfYear } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getTwoLastSymbolsOfYear'
import { editableFields } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/balanceOfTrade/config'
import { RenderNumberColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/balanceOfTrade/renderNumberColumn/RenderNumberColumn'
import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { IColumn } from '../../styledComponents/styledTable/types'
import styles from '../BalanceOfTrade.module.scss'

interface IProps {
  currentYear: number
  onChange: (field: string, keyValue: string) => (value: string | number) => void
  netNdpValue: ActualsValueTypes
}

export const getBoTColumns = ({
  currentYear,
  onChange,
  netNdpValue,
}: IProps): IColumn<IBalanceOfTrade>[] => {
  const twoYearsAgoField = getFieldByActualsValueType<IBalanceOfTrade>(
    'TwoYearsAgoTotal',
    netNdpValue
  )
  const prevYearField = getFieldByActualsValueType<IBalanceOfTrade>('PrevYearTotal', netNdpValue)
  const currentYearField = getFieldByActualsValueType<IBalanceOfTrade>(
    'CurrentYearTotal',
    netNdpValue
  )

  return [
    {
      field: 'Name',
      title: '$M USD',
      renderComponent: ({ value }) => (
        <div
          className={classNames(
            styles.textItem,
            styles.textItem_withMinHeight,
            styles.textItem_fixMinWidth
          )}
        >
          <Translation text={value as string} />
        </div>
      ),
    },
    {
      field: twoYearsAgoField,
      titleRenderFn: () => <div>FY'{getTwoLastSymbolsOfYear(currentYear - 2)}</div>,
      renderComponent: ({ value, keyValue }) => (
        <RenderNumberColumn
          value={value}
          keyValue={keyValue}
          editableFields={editableFields}
          onChange={onChange}
          field={twoYearsAgoField}
        />
      ),
    },
    {
      field: prevYearField,
      titleRenderFn: () => <div>FY'{getTwoLastSymbolsOfYear(currentYear - 1)}</div>,
      renderComponent: ({ value, keyValue }) => (
        <RenderNumberColumn
          value={value}
          keyValue={keyValue}
          editableFields={editableFields}
          onChange={onChange}
          field={prevYearField}
        />
      ),
    },
    {
      field: currentYearField,
      titleRenderFn: () => <div>FY'{getTwoLastSymbolsOfYear(currentYear)}</div>,
      renderComponent: ({ value, keyValue }) => (
        <RenderNumberColumn
          value={value}
          keyValue={keyValue}
          editableFields={editableFields}
          onChange={onChange}
          field={currentYearField}
        />
      ),
    },
  ]
}
